import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import PdfLayout from "./pdf-layout"
import { getCachePdfData } from "@/apis/pdf-api"

const PdfPrint = () => {
  const [searchParams] = useSearchParams()

  const pdfId = searchParams.get("id")

  const [data, setData] = useState(null)

  useEffect(() => {
    if (!pdfId) return

    const init = async () => {
      try {
        const data = await getCachePdfData(pdfId)

        setData(data)
      } catch (err) {
        console.error(err)
      }
    }

    init()
  }, [pdfId])

  // 데이터 로딩 전 렌더 막기
  if (!data) return null

  const { info, xLabels, series } = data

  return <PdfLayout info={info} xLabels={xLabels} series={series} />
}

export default PdfPrint
